import React, { Component } from 'react'
import { Grid, Stack } from '@mui/material'
import { Line } from 'components/data_display'
import Skeleton from '@mui/material/Skeleton'

/**
 * Skeleton para idiomas data [ academias>grupos ]
 */
export default class SkeletonIdiomasData extends Component {

    /**
     * Render
     *
     * @returns {Component}
     */
    render() {

        return (

            <Grid container px={5}>
                <Grid container spacing={1} mt={2} >

                    <Grid item xs={12}>
                        <Grid item container spacing={1} justifyContent="space-between">

                            <Grid item xs={6}>
                                <Stack>
                                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"} height={'50px'} />
                                </Stack>
                            </Grid>

                            <Grid item xs={6}>
                                <Stack>
                                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"} height={'50px'} />
                                    <Stack>
                                        <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"10%"} height={'50px'} />
                                    </Stack>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid container mt={4}>
                    <Line />
                </Grid>
                <Grid container mt={4} justifyContent="space-between">

                    <Grid item xs={4}>
                        <Stack>
                            <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"} height={'50px'} />
                            <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"10%"} height={'50px'} />
                        </Stack>
                    </Grid>

                </Grid>

                <Grid container >

                    <Grid item xs={12}>
                        <Skeleton variant="text" sx={{ fontSize: '1em' }} height={'200px'} width={"90%"} />
                    </Grid>
                </Grid>

            </Grid>

        )
    }
}
